import React from 'react';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';

const asVariable = (key) => `{${key}}`;

/**
 * Variáveis que o texto aceita. Um clique insere {variavel} onde o cursor estava
 * (no assunto ou no texto, o último campo usado). Também lista os blocos ilustrados
 * (title e tokenOf próprios: o bloco entra como está).
 * @param {{ variables: Array<{ key: string, label: string }>, onInsert: Function, title?: string, tokenOf?: Function }} props
 */
function VariableChips({ variables, onInsert, title = 'Variáveis (clique para inserir)', tokenOf = asVariable }) {
  if (!variables?.length) return null;
  return (
    <Box>
      <Typography variant="caption" color="text.secondary" component="div" sx={{ mb: 0.5 }}>
        {title}
      </Typography>
      <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.75 }}>
        {variables.map((variable) => (
          <Tooltip key={variable.key} title={variable.label}>
            <Chip
              size="small"
              variant="outlined"
              label={tokenOf(variable.key).trim()}
              onMouseDown={(e) => e.preventDefault()}
              onClick={() => onInsert(tokenOf(variable.key))}
              sx={{ fontFamily: 'monospace', fontSize: '0.75rem' }}
            />
          </Tooltip>
        ))}
      </Box>
    </Box>
  );
}

export default VariableChips;
